export const ERROR_LEVEL = []
export const WARN_LEVEL = ['warn']
export const INFO_LEVEL = ['warn', 'info']

class Reporter {
  getBrowser() {
    /* istanbul ignore next */
    if (!navigator) {
      return {}
    }
    const { cookieEnabled, userAgent } = navigator
    return {
      cookieEnabled,
      userAgent,
    }
  }

  constructor(
    /* istanbul ignore next */
    level = ERROR_LEVEL,
    /* istanbul ignore next */
    config = {},
    /* istanbul ignore next */
    initFn = () => {},
    /* istanbul ignore next */
    captureException = () => {}
  ) {
    this.config = config
    this.initFn = initFn
    this.captureException = captureException
    this.initFn(config)
    this.timeout = null
    this.stacks = []

    /* istanbul ignore next */
    this.ORIGINAL_ERROR_FN = {
      error: console ? console.error : () => {},
      warn: console ? console.warn : () => {},
      info: console ? console.info : () => {},
    }

    /* istanbul ignore next */
    this.errFn =
      typeof this.captureException === 'function'
        ? this.captureException
        : this.sendError

    level.forEach((type) => {
      console[type] = (error) => {
        this.stackMessage(type, error)
        return this.ORIGINAL_ERROR_FN[type](error)
      }
    })

    window.onerror = (message, url, linenumber) => {
      this.stackMessage('error', {
        message: message,
        file: url,
        linenumber: linenumber,
      })
    }
  }

  stackMessage(type, error) {
    const title =
      typeof error === 'string' ? error.replace('\n\n') : error.message
    if (
      this.stacks.find(
        ({ error, type: t }) => error.message === title && t === type
      )
    ) {
      return
    }
    this.stacks.push({
      type,
      error: {
        message: title,
        stack: error.stack,
        file: error.file,
        linenumber: error.linenumber,
      },
      config: this.config,
      browser: this.getBrowser(),
    })
    if (!this.timeout) {
      this.timeout = setTimeout(
        (() => {
          this.errFn(this.stacks)
          this.stack = []
          clearTimeout(this.timeout)
        }).bind(this),
        2000
      )
    }
  }

  /* istanbul ignore next */
  async sendError(error) {
    await fetch(this.captureException, {
      method: 'POST',
      mode: 'cors',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(error),
    })
  }
}

export default Reporter
